import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-action-bar', {
    height: '23px',
    display: '-webkit-flex',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    padding: '7px 12px 7px 18px',
});

cssRule('.tb-action-bar-left', {
    display: '-webkit-flex',
    flexBasis: '100%',
    '-webkit-flex-basis': '100%',
    whiteSpace: 'nowrap',
});

cssRule('.tb-action-bar-center', {
    display: '-webkit-flex',
    justifyContent: 'center',
    '-webkit-justify-content': 'center',
    flexBasis: '100%',
    '-webkit-flex-basis': '100%',
    whiteSpace: 'nowrap',
});

cssRule('.tb-action-bar-right', {
    display: '-webkit-flex',
    justifyContent: 'flex-end',
    '-webkit-justify-content': 'flex-end',
    flexBasis: '100%',
    '-webkit-flex-basis': '100%',
    whiteSpace: 'nowrap',
});

cssRule('.tb-select-action-menu-container', {
    display: 'inline-block',
    width: '250px',
});

cssRule('.tb-action-bar-divider', {
    display: 'inline-block',
    verticalAlign: 'top',
    marginLeft: '6px',
    marginRight: '6px',
    width: '1px',
    height: '23px',
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, '#e6e6e6'),
});

cssRule('.tb-filter-panel', {
    position: 'absolute',
    top: '37px',
    right: 'auto',
    bottom: 0,
    left: 'calc(100% - 240px)',
    width: '240px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    overflow: 'auto',
});

cssRule('.tb-items-panel', {
    position: 'absolute',
    top: '37px',
    right: 'auto',
    bottom: 0,
    left: 0,
    width: '100%',
});

cssRule('.tb-items-panel.tb-with-filter-panel', {
    right: '240px',
    width: 'calc(100% - 240px)',
});

cssRule('.tb-content-subplace-selector-label', {
    marginRight: '6px',
});

cssRule('.tb-content-subplace-selector .tb-popup-menu-button', {
    width: '144px',
});

